import React from "react";
import moment from "moment";
import Spinner from "react-bootstrap/Spinner";
import { Row, Col, Badge } from "react-bootstrap";

//Components
import InputReport from "../../Components/inputReport/inputReport";
import DatePicker from "../../Components/datePicker/datePicker";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";
import Alert from "../../Components/alert/Alert";
import FilterBox from "../../Components/filterBox/filterBox";
import ReportButtons from "../../Components/reports/ReportButtons";

//Services
import Api from "../../services/api";

//Styles
import "../Prelude/prelude.css";
import "./generalReports.css";
import styles from "../General/details.module.css";

class reportOrders extends React.Component {
  state = {
    text: "",
    resp: "",
    data: [],
    initialData: [],
    render: false,
    show: false,
    message: "",
    reload: false,
    loading: false,
    pocode: "",
    item: "",
    start_date: new Date().toLocaleDateString("pt-BR"),
    end_date: new Date().toLocaleDateString("pt-BR"),
  };

  async componentDidMount() {
    this.setState({ data: this.state.initialData });
    this.sendData();
  }

  filter = (data, name) => {
    if (data.length === 0) {
      this.setState({ data: this.state.initialData });
    } else {
      let result = this.state.data.filter(
        (value) => value[name].indexOf(data) > -1
      );
      if (result.length > 0) {
        this.setState({ data: result });
      }
    }
  };

  saveText = (data) => {
    const { value, name } = data;
    this.setState({ [`${name}`]: value });
  };

  filterData = (data, name) => {
    this.setState({ [`${name}`]: data });
  };

  callbackfunction = () => {
    this.setState({ show: false });
  };

  sendData = async () => {
    const params = {
      order: this.state.pocode,
      i: this.state.item,
      dt_ini: this.state.start_date,
      dt_end: this.state.end_date,
    };
    let count = 0;
    for (let p in params) {
      if (params[p]) count++;
    }

    if (count > 0) {
      this.setState({ loading: true });
      await Api.get(`/reports/orders`, { params: params })
        .then((resp) => {
          let arr = [];
          if (resp.data.length === 0) {
            this.setState({ render: false, loading: false });
          } else {
            resp.data.forEach((element) => {
              arr.push({
                Ordem: element.Ordem,
                Item: element.Produto,
                ["Máquina"]: element["Máquina"],
                Data: moment(element["Data"]).format("DD/MM/YYYY").toString(),
                Hora: element.hour_created,
                ["À produzir"]: element["Total da OP"],
                ["Produzido"]: element.produced,
                Status: (
                  <Badge bg="primary">
                    {element.status == "EA" ? "Aberto" : "Baixado"}
                  </Badge>
                ),
              });
            });
            this.setState({
              data: arr,
              render: true,
              initialData: arr,
            });
            if (this.state.loading) this.setState({ loading: false });
          }
        })
        .catch((err) => {
          this.setState({
            message: "Erro de conexão com o servidor.",
            show: true,
          });
        });
    } else {
      alert("Preencha um campo de filtro");
    }
  };

  excelbutton = (event) => {
    if (this.state.data.length === 0) {
      alert("Preencha um campo de filtro");
      event.preventDefault();
    }
  };

  render() {
    let keys = null;
    const row = ({ record }) => {
      const keys = Object.keys(record);
      return (
        <tr key={record.id}>
          {keys.map((key) => (
            <td key={key}>{record[key]}</td>
          ))}
        </tr>
      );
    };

    if (this.state.render) {
      keys = Object.keys(this.state.data[0]);
    }

    let { show, message, reload } = this.state;
    return (
      <>
        {show ? (
          <Alert
            show={show}
            message={message}
            parentCallback={this.callbackfunction}
            reload={reload}
          />
        ) : null}

        <FilterBox title="Filtros" order>
          <Row type="input" className="w-100 justify-content-between">
            <Col lg={4} sm={12} type="input" className="p-1 mb-1">
              <InputReport
                name="pocode"
                parentCallback={this.saveText}
                title="Código da ordem"
                focus={true}
              />
            </Col>
            <Col lg={4} sm={12} type="input" className="p-1 mb-1">
              <InputReport
                name="item"
                parentCallback={this.saveText}
                title="Item"
              />
            </Col>
            <Col lg={3} sm={12} type="input" className="p-1 mb-1">
              <DatePicker
                name="Data"
                title="Data"
                parentCallback={(e) => this.filterData(e, "start_date")}
              ></DatePicker>
            </Col>
          </Row>
          <ReportButtons
            type="input"
            handleClick={this.sendData}
            excelData={this.state.data}
            surnameFile="ordens"
          />
        </FilterBox>

        <div className="filters boxReport">
          {this.state.loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "400px",
              }}
            >
              <div className={styles.loader}>
                <Spinner variant="success" animation="border" />
                <strong>Carregando...</strong>
              </div>
            </div>
          ) : (
            <div className="TableReport">
              {this.state.render ? (
                <TableList data={this.state.data}></TableList>
              ) : (
                <div>
                  <MessageTable message={"Sem dados para processar."} />
                </div>
              )}
            </div>
          )}
        </div>
      </>
    );
  }
}

export default reportOrders;
